export default "__VITE_ASSET__EgjtTZ54__"